var vendorCategoriesForProd = [];
var vendorSpecialitiesForProd = [];
var ProductImages = [];
var img1flag;
var img2flag;
var img3flag;
var imageIsImage;
var imageIsImageTwo;
var imageIsImageThree;
var ImageURL;
var vendorProductNames = [];
var SpecialitiesArray = [];
var imagesNotChanges = false;
var currentEditedproductName;
var currentEditedproductId;
var VendorCropper = "";
var currentProductID = "";
var currentProductId = "";
var productToBeDeleted = "";
var productImagePrefix = "";
var oldProductImageURL = "";
var newProductImageURL = "";

function toBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);

    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
import { getImageUrl, getVendorBusinessImageUrl, getAssetUrl } from "../helpers/mediaUrl";
export default class vendor_servicing_product_listing {
  constructor() {
    this.formstep1 = $("#formstep1");
    this.formstep2 = $("#formstep2");
    this.formstep3 = $("#formstep3");
    this.formstep4 = $("#formstep4");
    this.formstep5 = $("#formstep5");

    this.inputGSTRegistered = $("#inputGSTRegistered");

    this.listingPageSmtBtn = $("#listingPageSmtBtn");
    this.listingPagePrevBtn = $("#listingPagePrevBtn");
    this.productServicesListingPage = $(".vendor_servicing_product_listing"); // changed class
    this.GSTDetails_page = $(".GSTDetails-page");
    this.Products_Services_page4 = $(".vendor_servicing_product_details"); //changed class
    this.uploadDocuments_page5 = $(".vendorUploadDocuments");
    this.inputProductServiceName = $("#inputProductServiceName");
    this.inputDiscription = $("#inputDiscription");

    this.inputCategory = $("#inputCategory");
    this.NoProductsError = $("#NoProductsError");

    this.inputPrice = $("#inputPrice");
    this.inputQuantity = $("#inputQuantity");
    this.checkNonVeg = $("#checkNonVeg");
    this.checkreco = $("#checkreco");
    this.currentProductChanged = $("#currentProductChanged");

    this.addNewProductBtn = $("#addNewProductBtn");
    this.page4SubmitBtn = $("#page4SubmitBtn");
    this.productCards = $("#productCards");
    this.ProductsServicesForm4 = $("#Products-Services-Form4");

    this.inputDiscription = $("#inputDiscription");
    this.AddNewProductsServicespage4 = $(".AddNew-Products-Services-page4");
    this.productSericeDetailsDiv = $("#productSericeDetailsDiv");

    this.inputProductServiceNameError = $("#inputProductServiceNameError");
    this.discriptionError = $("#discriptionError");
    this.categoryError1 = $("#categoryError1");
    this.GSTPercentError = $("#GSTPercentError");
    this.priceError = $("#priceError");
    this.quantityError = $("#quantityError");
    this.imageOneError = $(".image-1-error");
    this.imageTwoError = $(".image-2-error");
    this.imageThreeError = $(".image-3-error");

    this.specicalityError = $("#speciality-error");
    this.CannotDeleteProductMsg = $("#CannotDeleteProductMsg");

    // Initialize data
    this.initCategories();

    // Registering Events
    this.bindEvents();
  }

  initCategories = async () => {
    try {
      const res = await $.ajax({
        type: "GET",
        url: baseURL + "api/Vendor/GetVendorCategories",
        headers: { Authorization: X_API_KEY }
      });
      window.allVendorCategories = res || [];
    } catch (err) {
      window.allVendorCategories = window.allVendorCategories || [];
    }
  };
  bindEvents = () => {
    this.listingPageSmtBtn.on("click", this.ValidateAtleastOneProduct);
    this.listingPagePrevBtn.on("click", this.ListingPagePrevAction);
    this.addNewProductBtn.on("click", this.addNewProduct);
    // this.page4SubmitBtn.on("click", this.displayProducts);
    this.displayProducts();

    $("#ProductServiceListingDiv").on("click", ".deleteProduct", (e) => {
      e.preventDefault(); // STOP RELOAD IMMEDIATELY
      e.stopPropagation();
      this.checkOrders(e); // Then proceed to check logic
    });

    $("#ProductServiceListingDiv").on(
      "click",
      ".editProduct",
      this.doEditProduct,
    );

    $("#ProductServiceListingDiv").on(
      "click",
      ".qtyminus",
      this.qtyMinusbutton,
    );

    $("#ProductServiceListingDiv").on("click", ".qtyplus", this.qtyPlusbutton);

    $("#ProductServiceListingDiv").on("change", ".qty", this.onChangeInput);

    $("#ProductServiceListingDiv").on(
      "click",
      ".availableCheckBox",
      this.updateProductAvailabilityFlag,
    );
  };

  qtyPlusbutton = (e) => {
    // Stop acting like a button
    e.preventDefault();

    var current_input_ID = e.target.name;
    document.getElementById("current_input_ID");

    // Get the field name
    // fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt(document.getElementById(current_input_ID).value);

    // If is not undefined
    if (!isNaN(currentVal)) {
      // Increment
      // $('input[name=' + fieldName + ']').val(currentVal + 1);
      document.getElementById(current_input_ID).value = currentVal + 1;
      this.quanityBtn(current_input_ID);
    } else {
      // Otherwise put a 0 there
      // $('input[name=' + fieldName + ']').val(0);
      document.getElementById(current_input_ID).value = 0;
      this.quanityBtn(current_input_ID);
    }
  };

  qtyMinusbutton = (e) => {
    // Stop acting like a button
    e.preventDefault();

    var current_input_ID = e.target.name;
    document.getElementById("current_input_ID");

    // Get the field name
    // fieldName = $(this).attr('field');
    // Get its current value
    var currentVal = parseInt(document.getElementById(current_input_ID).value);

    // If is not undefined
    if (!isNaN(currentVal) && currentVal != 0) {
      // Increment
      // $('input[name=' + fieldName + ']').val(currentVal + 1);
      document.getElementById(current_input_ID).value = currentVal - 1;
      this.quanityBtn(current_input_ID);
    } else {
      // Otherwise put a 0 there
      // $('input[name=' + fieldName + ']').val(0);
      document.getElementById(current_input_ID).value = 0;
      this.quanityBtn(current_input_ID);
    }
  };

  onChangeInput = (e) => {
    var currentID = e.target.id;

    var currentVal = parseInt(document.getElementById(currentID).value);

    if (currentVal >= 0) {
      this.quanityBtn(currentID);
    } else {
      document.getElementById(currentID).value = 0;
      this.quanityBtn(currentID);
    }
  };

  quanityBtn = (currentID) => {
    var currentVal = parseInt(document.getElementById(currentID).value);

    $.ajax({
      type: "POST",
      url: baseURL + "api/vendor/updateProductQuantity",
      data: {
        Product_ID: currentID,
        Quantity: currentVal,
      },
      headers: { Authorization: X_API_KEY },
      success: function (res) {},
    });
  };

  displayProducts = (e) => {
    this.NoProductsError.html("");
    $.ajax({
      type: "GET",
      url: baseURL + "api/Vendor/GetProductsByCategory",

      headers: { Authorization: X_API_KEY },
      success: this.doDisplayProdsByCategory,
    });
  };

  checkOrders = (e) => {
    const button = e.currentTarget || e.target.closest(".deleteProduct");
    const Product_ID = $(button).data("id");
    const Product_Name = $(button).data("name");

    productToBeDeleted = {
      productId: Product_ID,
      productName: Product_Name,
    };

    if (!Product_ID) {
      console.error("Could not find Product ID for delete check.");
      return;
    }

    $.ajax({
      type: "GET",
      url: baseURL + "api/Vendor/GetOrdersForDeleteProduct",
      data: {
        Product_ID: Product_ID,
      },
      headers: { Authorization: X_API_KEY },
      success: this.checkIfCanDeleteProduct,
    });
  };

  // checkIfCanDeleteProduct = (res) => {
  //   if (res != true) {
  //     $("#CannotDeleteProductMsg").empty();
  //     res.forEach((element) => {
  //       var item = `${element.Order_No}<br>`;
  //       $("#CannotDeleteProductMsg").append(item);
  //     });

  //     window.$("#DeleteErrorModal").modal("show");
  //   } else if (res == true) {
  //     this.doDeleteProduct();
  //   }
  // };

  // doDeleteProduct = (e) => {
  //   // var e = productToBeDeleted;
  //   e.preventDefault();
  //   e.stopPropagation();

  //   var deletedProdServName = e.target.attributes[2]["nodeValue"];

  //   $.ajax({
  //     type: "POST",
  //     url: baseURL + "api/vendor/deleteProductByName",
  //     headers: { Authorization: X_API_KEY },
  //     data: {
  //       productServiceName: deletedProdServName,
  //     },
  //     success: function (res) {},
  //   });
  //   $.ajax({
  //     type: "Post",
  //     url: baseURL + "api/Vendor/DeleteProduct",
  //     async: false,
  //     data: { Product_ID: e.target.classList[1] },
  //     headers: { Authorization: X_API_KEY },
  //     success: this.displayProducts,
  //   });
  // };

  checkIfCanDeleteProduct = (res) => {
    // res is the response from GetOrdersForDeleteProduct
    if (res !== true) {
      $("#CannotDeleteProductMsg").empty();
      // res is likely an array of orders preventing deletion
      if (Array.isArray(res)) {
        res.forEach((element) => {
          var item = `${element.Order_No}<br>`;
          $("#CannotDeleteProductMsg").append(item);
        });
      }

      window.$("#DeleteErrorModal").modal("show");
    } else {
      // Pass stored product details to delete flow
      this.doDeleteProduct(productToBeDeleted);
    }
  };

  doDeleteProduct = (productMeta) => {
    const productId = productMeta?.productId;
    const productName = productMeta?.productName;

    if (!productId) {
      console.error("Could not find Product ID for deletion.");
      return;
    }

    const deleteById = () => {
      $.ajax({
        type: "POST",
        url: baseURL + "api/Vendor/DeleteProduct",
        data: { Product_ID: productId },
        headers: { Authorization: X_API_KEY },
        success: () => {
          this.displayProducts();
        },
        error: (err) => {
          console.error("Error deleting product by ID:", err);
        },
      });
    };

    // Optional cleanup by name, then guaranteed delete by ID
    if (productName) {
      $.ajax({
        type: "POST",
        url: baseURL + "api/vendor/deleteProductByName",
        headers: { Authorization: X_API_KEY },
        data: {
          productServiceName: productName,
        },
        complete: () => {
          deleteById();
        },
      });
      return;
    }

    deleteById();
  };
  doEditProduct = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const productId = $(e.currentTarget).data("id");

    this.currentProductChanged.prop("checked", true);

    currentProductID = productId;
    currentProductId = productId;
    this.Products_Services_page4.removeClass("d-none");
    this.productServicesListingPage.addClass("d-none");

    $.ajax({
      type: "POST",
      url: baseURL + "api/Vendor/GetProduct",
      data: { Product_ID: productId },
      headers: { Authorization: X_API_KEY },
      success: this.displayProductDetails,
    });
  };
  doDisplayProdsByCategory = (res) => {
    const categories = res.Categories || res.categories || [];
    
    if (!categories || categories.length === 0) {
      $("#ProductServiceListingDiv").html("<div class='col-12 text-center p-5'><h5>No categories associated yet.</h5><p>Please check your profile settings to manage categories.</p></div>");
      return;
    }

    //To make the collapsable boxes function
    var collapsableBoxCounter = 444;
    //To give unique ids to the speciality checkboxes
    var ProductCount = 1;
    
    //to avoid duplicates
    $("#ProductServiceListingDiv").empty();
    
    let renderedCount = 0;
    categories.forEach((categoryName) => {
      //To load products of current Category
      var itemBody = ``;

      const products = res[categoryName];
      if (!products || !Array.isArray(products) || products.length === 0) {
        return;
      }
      
      renderedCount++;
      //to append products
      products.forEach((product) => {
        var availabilityFlag = product.Product_Availability_Flag
          ? "checked"
          : "";

        var newImageURL = product.Image_URL
          ? product.Image_URL.replace(/01.png$/, "")
          : "";

        var ProdIconImg = product.Product_ID + "ProdIconImg";

        itemBody = `${itemBody}<div class="row border mt-3 mb-3 pb-1">
        <!-- col 1 picture -->
        <div class="col-md-2 col-4 mt-3 mb-3 d-flex justify-content-center">
        <img src="${getImageUrl(product.Image_URL)}" class="img-load img-fluid my-auto ${ProdIconImg}" width="70%" onerror="this.src='${baseURL}assets/src/images/pancake.jpeg'" alt="Image">
        </div>

        <!-- col 2 written part -->
        <div class="col-md-8 col-8 mt-3 ">
            <h6 class="productListing-Truncate2">${product.Product_Service_Name}</h6>
            <span class="productListing-Truncate2">${product.Description || ""}</span>
        </div>
        <!-- <div class="col-8 col-md-0"></div> -->
        <div class="col-md-2 col-12 mt-3 my-auto d-flex justify-content-end">
        <div class="row ">
          <div class="col-12 d-flex justify-content-end">
            <button type="button" class="editProduct" data-id="${product.Product_ID}" style="border: none; background-color: transparent;outline: none;">EDIT</button>
            <button type="button" class="deleteProduct" data-id="${product.Product_ID}" data-name="${product.Product_Service_Name}" style="margin-left:30px;border: none; background-color: transparent;outline: none;">DELETE</button>
          </div>
          <div class="col-12 mt-2 d-flex justify-content-end ">
            <div class="form-check form-switch " style="padding-left:0px;">
              <input class="form-check-input ms-0 productSwitch ${product.Product_ID}" type="checkbox" role="switch" id="flexSwitchCheckDefault" ${availabilityFlag}>
            </div>
          </div>
        </div>
        </div>
        </div>`;
        ProductCount++;
      });

      var item1 = `<div id="accordion-${collapsableBoxCounter}" role="tablist" aria-multiselectable="true" class="o-accordion mt-2">
      <div class="card multi">
        <div class="card-header" role="tab" id="headingOne-${collapsableBoxCounter}">
            <h5 class="mb-0">
                <div class="row row justify-content-between">
                    <div class="col-11">
                        &nbsp;
                        <p class="mb-0">${categoryName}</p>
                    </div>
                    <div class="col-1 d-flex justify-content-end align-items-center">
                        <a data-toggle="collapse" data-parent="#accordion" href="#collapseOne-${collapsableBoxCounter}" aria-expanded="true" aria-controls="collapseOne-${collapsableBoxCounter}">
                             <img src="${baseURL}assets/src/images/arrow-down-circle.svg" width="20" height="20" class="mx-auto d-block" alt="^">
                        </a>
                    </div>
                </div>
            </h5>
        </div>

        <!-- Products COLLAPSABLE CARD -->
        <div id="collapseOne-${collapsableBoxCounter}" class="collapse show" role="tabpanel" aria-labelledby="headingOne-${collapsableBoxCounter}">
            <div class="card-block p-3">
                <div class="container-fluid">
                    <div class="row justify-content-center" id="SpecialitiesDisplay" >${itemBody}</div>
                </div>
            </div>
        </div>
      </div>
    </div>`;

      $("#ProductServiceListingDiv").append(item1);
      collapsableBoxCounter++;
    });

    //     <!-- col 1 picture -->
    //     <div class="col-md-2 col-4 mt-3 mb-3 d-flex justify-content-center">
    //         <img src="assets/src/images/pancake.jpeg" class="img-load img-fluid my-auto" width="70%">
    //     </div>

    //     <!-- col 2 written part -->
    //     <div class="col-md-8 col-8 mt-3 ">
    //         <h6 class="productListing-Truncate2">${element.Product_Service_Name}</h6>
    //         <span class="productListing-Truncate2">${element.Description}</span>
    //     </div>
    //     <!-- <div class="col-8 col-md-0"></div> -->
    //     <div class="col-md-2 col-12 mt-3 my-auto d-flex justify-content-end">
    //     <button type="button" class="editProduct ${element.Product_ID}" style="border: none; background-color: transparent;outline: none;">EDIT</button><button type="button" class="deleteProduct ${element.Product_ID}" style="margin-left:30px;border: none; background-color: transparent;outline: none;">DELETE</button>

    //     </div>

    // </div>`;
    //     $("#productCards").append(item);
    //
    //   });

    // these are used when the products are loaded first time and then edit or delete button is clicked, as the above events are binded on load only, so to make them work after edit or delete also we have bind them here using event delegation
    // $(".deleteProduct").on("click", this.checkOrders);
    // $(".editProduct").on("click", this.doEditProduct);
    // $(".qtyminus").on("click", this.qtyMinusbutton);
    // $(".qtyplus").on("click", this.qtyPlusbutton);
    // $(".qty").on("change", this.onChangeInput);
    // $(".availableCheckBox").on("click", this.updateProductAvailabilityFlag);
    if (renderedCount === 0) {
      $("#ProductServiceListingDiv").html("<div class='col-12 text-center p-5'><h5>No products found.</h5><p>Click 'Add New' to add your first product or service.</p></div>");
    }
  };


  updateProductAvailabilityFlag = (e) => {
    var currentID = e.target.name;
    var checkbox = document.getElementById(currentID);

    var isChecked = e.target.checked;
    if (isChecked) {
      isChecked = 1;
    } else {
      isChecked = 0;
    }

    $.ajax({
      type: "POST",
      url: baseURL + "api/vendor/UpdateProductAvailability",
      data: {
        Product_ID: currentID,
        availabilityFlag: isChecked,
      },
      headers: { Authorization: X_API_KEY },
      success: function (res) {},
    });
  };

  ListingPagePrevAction = (e) => {
    e.preventDefault();
    this.GSTDetails_page.removeClass("d-none");
    this.productServicesListingPage.addClass("d-none");
    this.formstep4.removeClass("current-item");
    this.formstep3.addClass("current-item");
  };

  showCategoryOptionsProd = (res) => {
    vendorCategoriesForProd = res;
  };

  showSpecialityOptionsProd = (res) => {
    vendorSpecialitiesForProd = res;
  };

  bindImagePreview = () => {
    const mapping = [
      { input: "inpFile1", preview: "servicingimageCropInputPreviewForEdit1" },
      { input: "inpFile2", preview: "servicingimageCropInputPreviewForEdit2" },
      { input: "inpFile3", preview: "servicingimageCropInputPreviewForEdit3" },
    ];

    mapping.forEach(({ input, preview }) => {
      const fileInput = document.getElementById(input);
      const imgPreview = document.getElementById(preview);

      if (!fileInput || !imgPreview) return;

      fileInput.addEventListener("change", function () {
        const file = this.files[0];
        if (!file) return;

        imgPreview.src = URL.createObjectURL(file);
      });
    });
  };
  displayProductDetails = async (res) => {
    currentProductID = res.Product_ID;
    var itemCategories = ``;
    var itemSpecialities = ``;
    var itemCategorySelected = null;
    var itemSpecialitySelected = null;
    var SpecialityCount = ``;

    //store prefix to generate ImageURL later
    productImagePrefix = res.Image_URL;
    var originalString = productImagePrefix;
    // Find the last occurrence of '/'
    var lastIndex = originalString.lastIndexOf("/");
    // Trim the string from the end until the last '/'
    var trimmedString = originalString.substring(0, lastIndex);
    //For S3 bucket folder name change
    oldProductImageURL = trimmedString;
    //To remove old product name
    originalString = trimmedString;
    // Find the last occurrence of '/'
    lastIndex = originalString.lastIndexOf("/");
    // Trim the string from the end until the last '/'
    productImagePrefix = originalString.substring(0, lastIndex + 1);

    await new Promise((resolve) => {
      $.ajax({
        type: "GET",
        url: baseURL + "api/Vendor/GetVendorCategories",
        headers: { Authorization: X_API_KEY },

        success: (res) => {
          this.showCategoryOptionsProd(res);
          resolve();
        },
        error: resolve,
      });
    });
    await new Promise((resolve) => {
      $.ajax({
        type: "GET",
        url: baseURL + "api/Vendor/GetVendorSpecialities",
        headers: { Authorization: X_API_KEY },

        success: (res) => {
          this.showSpecialityOptionsProd(res);
          resolve();
        },
        error: resolve,
      });
    });
    vendorCategoriesForProd.forEach((element) => {
      //to select the option
      if (element.Picklist_ID == res.Picklist_ID) {
        itemCategorySelected = "selected";
      } else {
        itemCategorySelected = null;
      }
      //
      //
      itemCategories = `${itemCategories} <option class="categoryOptions" value='{"picklistId":"${element.Picklist_ID}","ExtraValue":"${element.extra_value}","IsFood":"${element.is_food}"}' ${itemCategorySelected}>${element.Picklist_display_value}</option>`;

      //   this.itemCategories.append(item);
    });
    vendorSpecialitiesForProd.forEach((element) => {
      itemSpecialitySelected = null;
      res.Product_Speciality.forEach((ele) => {
        if (element.Picklist_ID == ele) {
          itemSpecialitySelected = "checked";
        } else {
          // itemSpecialitySelected = null;
        }
      });

      // if(element.Picklist_display_value==)
      // var item = `<option value="${element.Picklist_display_value}">${element.Picklist_display_value}</option>`;
      itemSpecialities = `${itemSpecialities}<div class="col-4 col-md-2 d-flex justify-content-center my-2 "><div class="custom-control custom-checkbox image-checkbox">
        <input type="checkbox" name="speciality-check" class="EditspecialityCheckBox custom-control-input justify-content-center" id="specialityck${SpecialityCount}" value="${element.Picklist_ID}" ${itemSpecialitySelected}>
        <label class="custom-control-label d-flex justify-content-center" for="specialityck${SpecialityCount}">
            <img src="" id=${element.Picklist_ID} alt="#" class="img-fluid specialityImage" style="width: 96px; height: 96px; object-fit: contain; background-color: #f5f5f5; padding: 6px; border-radius: 8px;" onerror="this.src='${baseURL}/assets/default.png'" loading="lazy">
        </label>
        <label class="d-flex justify-content-center">
            <span class="fs-12 text-lowercase text-center">${element.Picklist_display_value}</span>
        </label>
        </div></div>`;
      SpecialityCount++;

      // categoryCount++;
    });

    var newImageURL = res.Image_URL.replace(/01.png$/, "");

    var isRecommended = res.Recommended_flag ? `checked` : ``;
    var isNonVeg = res.Veg_NonVeg_flag ? `checked` : ``;

    currentEditedproductName = res.Product_Service_Name;
    currentEditedproductId = res.Product_ID;

    $("#productSericeDetailsDiv").empty();
    var item = ` <div id="accordion-2" role="tablist" aria-multiselectable="true" class="o-accordion">
    <div class="">
        <!-- Product Services details CARD HEADER -->
        <div class="card ml-3 mb-2 mt-2" style="background: #ff385c;">

        <div class="card-body text-white">
            <h5 class="card-title">PRODUCTS / SERVICES LISTING</h5>

            


        </div>
    </div>
        <!-- Product Services details CARD -->
        <div class="card ml-3">

        <div id="collapseOne-3" class="collapse show" role="tabpanel" aria-labelledby="headingOne-3">
            <div class="card-block">
                <div class="container">
                    &nbsp;
                    <div class="mb-3">
                        <label for="inputProductServiceName" class="form-label">Product or Service Name</label>
                        <input type="text" class="form-control" id="inputProductServiceName" name="Product_Service_Name" aria-describedby="Product_Service_NameHelp" value="${res.Product_Service_Name}" data-originalname="${res.Product_Service_Name}">
                        <span class='text-danger' id='inputProductServiceNameError' ></span>
                    </div>
                    <div class="mb-3">
                    <input id="x" type="hidden" name="content" value='${res.Description ? res.Description.replace(/'/g, "&apos;") : ""}'>
                    <trix-editor input="x"></trix-editor>
                    <span class='text-danger' id="discriptionError"></span>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label for="inputState" class="form-label">Category</label>
                                <select class="form-select" aria-label="Default select example" id="inputCategory" name="Picklist_ID">
                                    <option class="categoryOptions"></option>${itemCategories}
                                </select>
                                <span class='text-danger' id="categoryError1"></span>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-3">
                                <label for="inputQuantity" class="form-label">Item Quantity</label>
                                <input type="number" class="form-control" id="inputQuantity" name="Quantity" value="${res.Quantity}">
                                (For service please enter number of enquiries you can service (e.g.100))
                                <span class='text-danger' id="quantityError"></span>
                            </div>
                        </div>
                    </div>
                    &nbsp;
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label for="inputPrice" class="form-label">Price (without GST)</label>
                                <input type="number" class="form-control " name="Price" id="inputPrice" value="${res.Price}">
                                <span class='text-danger' id="priceError"></span>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-3 showGSTReg d-none">
                                <label for="inputGSTPercent" class="form-label">GST %</label>
                                <input type="number" class="form-control" id="inputGSTPercent" name="GSTPercent_Address" aria-describedby="GSTPercent_AddressHelp" value="${res.GST}">
                                <span class='text-danger' id="GSTPercentError"></span>
                            </div>  
                        </div>
                    </div>

                    &nbsp;
                    <div class="row mb-3 ">

                        <label for="inputBusinessName" class="form-label">Specialities for this item</label>
                        <div id='specicalityError' class="text-danger"></div> 
                        <p>
                        <div id="ProductSpecialityBox" class="container d-flex flex-wrap">
                        ${itemSpecialities}
                            <!-- INTEGRATION OF SPECIALITIES HERE -->
                            <!-- <div><label class="mx-1 "><input type="checkbox" name="speciality-check" value="1" class="specialityCheckBox"><span>Italian</span></label></div> -->
                            <!-- <div><label class="mx-1 "><input type="checkbox" name="speciality-check" value="2" class="specialityCheckBox"><span>Indian</span></label></div> -->
                        </div>
                        </p>
                        <!-- <div class="d-flex bd-highlight">
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 1">

                        </div>
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 2">

                        </div>
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 3">

                        </div>
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 4">

                        </div>
                    </div> -->

                        <!-- <span class='text-danger' id="inputAddressError"></span> -->
                        &nbsp;

                        <div class="Vendor_image_cropper_page d-none">
                            <div class="container">
                                <h5>Upload Images</h5>
                                <form method="post" id="S3ImageSubmissionForm">
                                    <input type="file" name="image" class="image">
                                    <input type="file" name="image" class="image">
                                    <input type="file" name="image" class="image">
                                </form>
                            </div>
                        </div>

                        <label for="inputBusinessName" class="form-label">Upload images for this item</label>
                        <div class="d-flex bd-highlight">
                            <!-- <div class="container"> -->
                            <div class="row">
                                <div class="col-md-3">
                                    <input type="file" class="form-control imageCropInput prodImgInput editProdImgInput" id="inpFile1" name="inpFile1" value="servicingimageCropInputPreviewForEdit1" aria-describedby="">
                                    <div class="image-1-error text-danger"></div>
                                    <br>
                                    <div class="img-preview" >
                                        <img src="" alt="" class="image-preview-1 prodImgPreviewForEdit" id="servicingimageCropInputPreviewForEdit1" width="220px" height="auto">                            
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <input type="file" class="form-control imageCropInput prodImgInput  editProdImgInput" id="inpFile2" name="inpFile2" value="servicingimageCropInputPreviewForEdit2" aria-describedby="">
                                    <div class="image-2-error text-danger"></div>
                                    <br>
                                    <div class="img-preview-two " >
                                        <img src="" alt="" class="image-preview-2 prodImgPreviewForEdit" id="servicingimageCropInputPreviewForEdit2" width="220px" height="auto">
                                       
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <input type="file" class="form-control imageCropInput prodImgInput  editProdImgInput" id="inpFile3" name="inpFile3" value="servicingimageCropInputPreviewForEdit3" aria-describedby="">
                                    <div class="image-3-error text-danger"></div>
                                    <br>
                                    <div class="img-preview-three">
                                        <img src="" alt="" class="image-preview-3 prodImgPreviewForEdit" id="servicingimageCropInputPreviewForEdit3" width="220px" height="auto">
                                        
                                    </div>
                                </div>
                            </div>
                            
                            <!-- </div> -->
                            <!-- <div>
                            <div class="p-2 flex-grow-1 bd-highlight">
                                <input type="file" class="form-control" id="inpFile" name="inpFile" aria-describedby="" >
                            </div>
                            <div class="img-preview" id="imagePreview">
                                <img src="" alt="Image Preview 1" class="image-preview">
                            </div>
                            
                        </div> -->

                            <!-- <div>
                            <div class="p-2 flex-grow-1 bd-highlight">
                                <input type="file" class="form-control" id="inpFileTwo" name="inpFileTwo" aria-describedby="" >
                            </div>
                            <div class="img-preview-two" id="imagePreviewTwo">
                                <img src="" alt="Image Preview 2" class="image-preview-two">
                            </div>
                            
                        </div> -->

                            <!-- <div>
                            <div class="p-2 flex-grow-1 bd-highlight">
                                <input type="file" class="form-control" id="inpFileThree" name="inpFileThree" aria-describedby="" >
                            </div>
                            <div class="img-preview-three" id="imagePreviewThree">
                                <img src="" alt="Image Preview 3" class="image-preview-three">
                            </div>
                            
                        </div> -->
                        </div>
                        <!-- <span class='text-danger' id="inputAddressError"></span> -->
                        &nbsp;

                        <div class="d-flex bd-highlight">
                            <!-- <label for="checkreco" class="form-label">Recommended</label> -->
                            <div class="p-2 pl-4 pt-3 bd-highlight d-flex justify-content-end ">
                                <label><input class="form-check-input align-content-center checkbox-size  " type="checkbox" value="Recommended"  id="checkreco" ${isRecommended}><div class="ms-1 mt-1">Recommended</div></label>
                            </div>&emsp;&emsp;&emsp;
                            <div id="NonVegDiv">
                                <div class="p-2 pl-4 pt-3 bd-highlight d-flex justify-content-end ">
                                    <label><input class="form-check-input align-content-center checkbox-size  " type="checkbox" value="Non Veg" id="checkNonVeg" ${isNonVeg}><div class="ms-1 mt-1">Non Veg</div></label>
                                </div>
                            </div>
                        </div>
                        <!-- <span class='text-danger' id="inputAddressError"></span> -->
                        &nbsp;

                    </div>

                </div>
            </div>
        </div>
        </div>
    </div>
   
    </div>
    <div class="card ml-3">

    <div class="page_4_btns">
      <div class="row">
            <div class="col justify-content-start">
                  <button type="button" id="EditProductPrevBtn" class="btn btn-warning bg-orange basicDetailsBtn">PREVIOUS</button>
              </div>
              <div class="col d-flex justify-content-end ">
                  <button type="button" id="EditProductSubmitBtn" class="btn btn-warning text-uppercase bg-orange basicDetailsBtn">CONTINUE</button>
            </div>
       </div>
     </div>
     </div>
      &nbsp;
     `;

    $("#productSericeDetailsDiv").append(item);
    if (
      globalThis.cropperMain &&
      typeof cropperMain.doCroppingAction === "function"
    ) {
      cropperMain.doCroppingAction();
    }
    this.currentEditingProduct = res;
    this.bindImagePreview();

    //Load Product Images

    const images = [];

    // main image (always first)
    if (res.Image_URL) {
      images.push(getImageUrl(res.Image_URL));
    }

    // additional images
    if (res.Product_Images && res.Product_Images.length > 0) {
      res.Product_Images.forEach((img) => {
        if (img.Image_url) {
          images.push(getImageUrl(img.Image_url));
        }
      });
    }

    // set previews
    images.forEach((url, index) => {
      const imgEl = document.getElementById(
        `servicingimageCropInputPreviewForEdit${index + 1}`,
      );

      if (imgEl) imgEl.src = url;
    });

    if (
      globalThis.cropperMain &&
      typeof cropperMain.doCroppingAction === "function"
    ) {
      cropperMain.doCroppingAction();
    }

    this.getAllVendorProductsNames();

    if (this.inputGSTRegistered.is(":checked")) {
      $(".showGSTReg").removeClass("d-none");
    } else {
      $(".showGSTReg").addClass("d-none");
    }

    imagesNotChanges = true;
    img1flag = true;
    img2flag = true;
    img3flag = true;

    $("#EditProductPrevBtn").on("click", this.doEditPagePrev);
    $("#EditProductSubmitBtn").on("click", this.Submit_Form);

    $("#inputCategory").on("change", this.vegNonVegShow);
    $("#inputCategory").on("change", this.showSpecialityByCategory);

    this.vegNonVegShowInEdit();
    this.showSpecialityByCategory();
  };

  doEditProductValidation = (e) => {
    e.preventDefault();

    let isProductServiceNameValidated = this.ProductServiceName_validate();
    if (isProductServiceNameValidated) {
      $("#inputProductServiceNameError").html("");
    }

    let isDiscriptionValidated = this.Discription_validate();
    if (isDiscriptionValidated) {
      $("#discriptionError").html("");
    }

    let isCategoryValidated = this.Category_validate();
    if (isCategoryValidated) {
      $("#categoryError1").html("");
    }

    let isPriceValidated = this.Price_validate();
    if (isPriceValidated) {
      $("#priceError").html("");
    }

    let isQuantityValidated = this.Quantity_validate();
    if (isQuantityValidated) {
      $("#quantityError").html("");
    }

    let isGSTPercentValidated = this.GSTPercent_validate();
    if (isGSTPercentValidated) {
      $("#GSTPercentError").html("");
    }

    let imageSelected = this.imageSelected_validate();
    if (imageSelected || imagesNotChanges) {
      $(".image-1-error").html("");
    }

    if (imageIsImage == false) {
      $(".image-1-error").html("Please select an image file");
    }

    if (imageIsImageTwo == false) {
      $(".image-2-error").html("Please select an image file");
    }

    if (imageIsImageThree == false) {
      $(".image-3-error").html("Please select an image file");
    }
    if (imagesNotChanges == true) {
      $(".image-1-error").html("");
      //////////////////////////////////////////////////////////
      //   FOR ONBOARDING ONLY ONE PRODUCT IMAGE IS REQUIRED  //
      //////////////////////////////////////////////////////////
      // $(".image-2-error").html("");
      // $(".image-3-error").html("");
    }
    let specialitySelected = this.editspecialitySelected_validate();
    if (specialitySelected) {
      $("#specicalityError").html(" ");
    }

    if (
      isProductServiceNameValidated &&
      isDiscriptionValidated &&
      isCategoryValidated &&
      isPriceValidated &&
      isQuantityValidated &&
      isGSTPercentValidated &&
      (imageSelected || imagesNotChanges) &&
      specialitySelected &&
      img1flag &&
      img2flag &&
      img3flag
    ) {
      //Resetting imagesNotChanges flag value
      imagesNotChanges = false;
      this.EditProductSubmitForm();
    }
  };
  doEditPagePrev = () => {
    this.Products_Services_page4.addClass("d-none");
    this.productServicesListingPage.removeClass("d-none");
  };

  EditProductSubmitForm = () => {
    //To generate the new image url for the product to be sent as data in api
    var prodNameForImageURL = $("#inputProductServiceName").val();
    var fullImageURLforEditedProduct = this.currentEditingProduct.Image_URL;

    //If product name is changes -> rename bucket folder
    // Get the value of the custom attribute
    var oldFolderName = $("#inputProductServiceName").data("originalname");
    var newFolderName = $("#inputProductServiceName").val();
    //

    this.Products_Services_page4.addClass("d-none");
    this.productServicesListingPage.removeClass("d-none");
    currentEditedproductName = null;
    var product_service_data = [];

    const selectedPicklistId = JSON.parse($("#inputCategory").val());

    SpecialitiesArray = [];

    for (let i = 0; i < $(".EditspecialityCheckBox:checked").length; i++) {
      SpecialitiesArray[i] = $(".EditspecialityCheckBox:checked")[
        i
      ].defaultValue;
    }

    var recoFlag;
    if ($("#checkreco").is(":checked")) {
      recoFlag = 1;
    } else {
      recoFlag = 0;
    }
    var NonVegFlag;
    if ($("#checkNonVeg").is(":checked")) {
      NonVegFlag = 1;
    } else {
      NonVegFlag = 0;
    }
    var newEditProductImages = [];
    // for (var i = 0; i < 3; i++) {
    //   if (String($(".editProdImgInput")[i]["value"]).length > 1) {
    //     var image = {
    //       imageFile: $(".prodImgPreviewForEdit")[i]["currentSrc"],
    //       imageNo: i + 1,
    //     };
    //     newEditProductImages.push(image);

    //     var prodImgFile = $(".prodImgPreviewForEdit")[i]["currentSrc"];
    //     var prodImgFileNo = i + 1;
    //     var prodImgFileName = $("#inputProductServiceName").val();

    //     ImageURL = this.UploadProductImages(
    //       prodImgFile,
    //       prodImgFileNo,
    //       prodImgFileName,
    //     );
    //   }
    // }
    ImageURL = fullImageURLforEditedProduct;
    // for (var i = 0; i < 3; i++) {
    //
    //   if (String($(".prodImgPreviewForEdit")[i]["currentSrc"]).length > 200) {
    //     var image = {
    //       imageFile: $(".prodImgPreviewForEdit")[i]["currentSrc"],
    //       imageNo: i + 1,
    //     };
    //     newEditProductImages.push(image);
    //   }
    // }
    //
    // $.ajax({
    //   type: "POST",
    //   url: baseURL + "api/Vendor/ImageUploadApi",
    //   async: false,

    //   data: {
    //     ProductImages: newEditProductImages,
    //     productServiceName: $("#inputProductServiceName").val(),
    //     Product_ID: currentProductID,
    //   },
    //   success: function (res) {
    //     ImageURL = res;
    //   },
    // });

    var ImagesUpdatedVar = false;

    $(".prodImgInput").each((index, element) => {
      if (element.value != "") {
        ImagesUpdatedVar = true;
      }
    });

    var product_detail = {
      Product_ID: currentEditedproductId,
      Product_Service_Name: $("#inputProductServiceName").val(),
      Picklist_ID: selectedPicklistId.picklistId,
      Description: $("trix-editor:visible").val() || $("trix-editor").val(),
      GST: $("#inputGSTPercent").val(),
      Quantity: $("#inputQuantity").val(),
      Price: $("#inputPrice").val(),
      Image_URL: fullImageURLforEditedProduct,
      Specialities: SpecialitiesArray,
      Recommended_flag: recoFlag,
      Veg_NonVeg_flag: NonVegFlag,
      ImagesUpdated: ImagesUpdatedVar,
    };

    product_service_data.push(product_detail);

    $.ajax({
      type: "POST",

      url: baseURL + "api/Vendor/AddUpdateProducts",

      headers: { Authorization: X_API_KEY },

      // data: this.Products_Services_Form4.serialize(),
      data: {
        product_service_data: product_service_data,
      },

      success: this.doAfterSuccessfulEdit,
    });

    this.displayProducts();
  };

  addNewProduct = (e) => {
    var newProductCategory = ``;
    var newProductSpecility = ``;
    var SpecialityCount = ``;
    e.preventDefault();

    //To display All vendor Categories for New Product
    window.allVendorCategories.forEach((element) => {
      newProductCategory = ` ${newProductCategory}<option class="categoryOptions" value='{"picklistId":"${element.Picklist_ID}","ExtraValue":"${element.extra_value}","IsFood":"${element.is_food}"}'>${element.Picklist_display_value}</option>`;
    });

    //To display All vendor Speciality for New Product

    // window.allVendorSpecialities.forEach((element) => {
    //   // newProductSpecility = `${newProductSpecility}<div><label class="mx-1 "><input type="checkbox" name="speciality-check" value="${element.Picklist_ID}" class="NewspecialityCheckBox"><span>${element.Picklist_display_value}</span></label></div>`;

    //   newProductSpecility = `${newProductSpecility}<div class="col-4 col-md-2 d-flex justify-content-center my-2 "><div class="custom-control custom-checkbox image-checkbox">
    //     <input type="checkbox" class="custom-control-input specialityCheckBox justify-content-center" id="specialityck${SpecialityCount}" value="${element.Picklist_ID}">
    //     <label class="custom-control-label d-flex justify-content-center" for="specialityck${SpecialityCount}">
    //         <img src="assets/src/images/pancake.jpeg" alt="#" class="img-fluid rounded-circle specialityImage">
    //     </label>
    //     <label class="d-flex justify-content-center">
    //         <span class="fs-12 text-lowercase text-center">${element.Picklist_display_value}</span>
    //     </label>
    //     </div></div>`;
    //   SpecialityCount++;
    // });

    this.productServicesListingPage.addClass("d-none");
    $(".vendor_servicing_product_details").removeClass("d-none");
    $("#productSericeDetailsDiv").empty();
    var ele = ` <div id="accordion-2" role="tablist" aria-multiselectable="true" class="o-accordion">
    <div class="">
        <!-- Product Services details CARD HEADER -->
        <div class="card ml-3 mb-2 mt-2" style="background: #ff385c;">

        <div class="card-body text-white">
            <h5 class="card-title">PRODUCTS / SERVICES LISTING</h5>

            <p>Add products or services to your listing.</p>


        </div>
    </div>
        <!-- Product Services details CARD -->
        <div class="card ml-3 p-3">

        <div id="collapseOne-3" class="collapse show" role="tabpanel" aria-labelledby="headingOne-3">
            <div class="card-block">
                <div class="">
                    &nbsp;
                    <div class="mb-3">
                        <label for="inputProductServiceName" class="form-label">Product or Service Name</label>
                        <input type="text" class="form-control" id="inputProductServiceName" name="Product_Service_Name" aria-describedby="Product_Service_NameHelp">
                        <span class='text-danger' id="inputProductServiceNameError"></span>
                    </div>
                    <div class="mb-3">
                    <input id="x" type="hidden" name="content" value="">
                    <trix-editor input="x"></trix-editor>
                    <span class='text-danger' id="discriptionError"></span>
                    </div>
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label for="inputState" class="form-label">Category</label>
                                <select class="form-select" aria-label="Default select example" id="inputCategory" name="Picklist_ID">
                                    <option class="categoryOptions"></option>${newProductCategory}
                                </select>
                                <span class='text-danger' id="categoryError1"></span>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-3">
                                <label for="inputQuantity" class="form-label">Item Quantity</label>
                                <input type="number" class="form-control" id="inputQuantity" name="Quantity">
                                (For service please enter number of enquiries you can service (e.g.100))
                                <span class='text-danger' id="quantityError"></span>
                            </div>
                        </div>
                    </div>
                    &nbsp;
                    <div class="row">
                        <div class="col">
                            <div class="mb-3">
                                <label for="inputPrice" class="form-label">Price (without GST)</label>
                                <input type="number" class="form-control " name="Price" id="inputPrice">
                                <span class='text-danger' id="priceError"></span>
                            </div>
                        </div>
                        <div class="col">
                            <div class="mb-3 showGSTReg d-none">
                                <label for="inputGSTPercent" class="form-label">GST %</label>
                                <input type="number" class="form-control" id="inputGSTPercent" name="GSTPercent_Address" aria-describedby="GSTPercent_AddressHelp">
                                <span class='text-danger' id="GSTPercentError"></span>
                            </div>
                        </div>
                    </div>

                    &nbsp;
                    <div class="row mb-3 ">

                        <label for="inputBusinessName" class="form-label">Specialities for this item</label>
                        <div id=speciality-error class="text-danger"></div>
                        <p>
                        <div id="ProductSpecialityBox" class="container d-flex flex-wrap">
                        
                            <!-- INTEGRATION OF SPECIALITIES HERE -->
                            <!-- <div><label class="mx-1 "><input type="checkbox" name="speciality-check" value="1" class="specialityCheckBox"><span>Italian</span></label></div> -->
                            <!-- <div><label class="mx-1 "><input type="checkbox" name="speciality-check" value="2" class="specialityCheckBox"><span>Indian</span></label></div> -->
                        </div>
                        </p>
                        <!-- <div class="d-flex bd-highlight">
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 1">

                        </div>
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 2">

                        </div>
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 3">

                        </div>
                        <div class="p-2 flex-grow-1 bd-highlight">
                            <input type="text" class="form-control" id="inputContactPersonName" name="Contact_Person" aria-describedby="contactPersonHelp" placeholder="Speciality 4">

                        </div>
                    </div> -->

                        <span class='text-danger' id="specicalityError"></span> 
                        &nbsp;

                        <div class="Vendor_image_cropper_page d-none">
                            <div class="container">
                                <h5>Upload Images</h5>
                                <form method="post" id="S3ImageSubmissionForm">
                                    <input type="file" name="image" class="image">
                                    <input type="file" name="image" class="image">
                                    <input type="file" name="image" class="image">
                                </form>
                            </div>
                        </div>

                        <label for="inputBusinessName" class="form-label">Upload images for this item</label>
                        <div class="d-flex bd-highlight">
                            <!-- <div class="container"> -->
                            <div class="row">
                                <div class="col-md-3">
                                    <input type="file" class="form-control imageCropInput" id="inpFile1" name="inpFile1" aria-describedby="" value="imageCropInputPreviewForNew1">
                                    <div class="image-1-error text-danger"></div>
                                    <br>
                                    <div class="img-preview" id="imagePreview1">
                                        <img src="" alt="" class="image-preview-1 prodImgPreviewForNew" id="imageCropInputPreviewForNew1" width="220px" height="auto">                            
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <input type="file" class="form-control imageCropInput" id="inpFile2" name="inpFile2" aria-describedby="" value="imageCropInputPreviewForNew2">
                                    <div class="image-2-error text-danger"></div>
                                    <br>
                                    <div class="img-preview-two" id="imagePreview2">
                                        <img src="" alt="" class="image-preview-2 prodImgPreviewForNew" id="imageCropInputPreviewForNew2" width="220px" height="auto">
                                       
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <input type="file" class="form-control imageCropInput" id="inpFile3" name="inpFile3" aria-describedby="" value="imageCropInputPreviewForNew3">
                                    <div class="image-3-error text-danger"></div>
                                    <br>
                                    <div class="img-preview-three" id="imagePreview3">
                                        <img src="" alt="" class="image-preview-3 prodImgPreviewForNew" id="imageCropInputPreviewForNew3" width="220px" height="auto">
                                        
                                    </div>
                                </div>
                            </div>
                            <!-- </div> -->
                            <!-- <div>
                            <div class="p-2 flex-grow-1 bd-highlight">
                                <input type="file" class="form-control" id="inpFile" name="inpFile" aria-describedby="" >
                            </div>
                            <div class="img-preview" id="imagePreview">
                                <img src="" alt="Image Preview 1" class="image-preview">
                            </div>
                            
                        </div> -->

                            <!-- <div>
                            <div class="p-2 flex-grow-1 bd-highlight">
                                <input type="file" class="form-control" id="inpFileTwo" name="inpFileTwo" aria-describedby="" >
                            </div>
                            <div class="img-preview-two" id="imagePreviewTwo">
                                <img src="" alt="Image Preview 2" class="image-preview-two">
                            </div>
                            
                        </div> -->

                            <!-- <div>
                            <div class="p-2 flex-grow-1 bd-highlight">
                                <input type="file" class="form-control" id="inpFileThree" name="inpFileThree" aria-describedby="" >
                            </div>
                            <div class="img-preview-three" id="imagePreviewThree">
                                <img src="" alt="Image Preview 3" class="image-preview-three">
                            </div>
                            
                        </div> -->
                        </div>
                        <!-- <span class='text-danger' id="inputAddressError"></span> -->
                        &nbsp;


                        <div class="d-flex bd-highlight">
                            <!-- <label for="checkreco" class="form-label">Recommended</label> -->
                            <div class="p-2 pl-4 pt-3 bd-highlight d-flex justify-content-end ">
                                <label><input class="form-check-input align-content-center checkbox-size  " type="checkbox" value="Recommended" id="checkreco"><div class="ms-1 mt-1">Recommended</div></label>
                            </div>&emsp;&emsp;&emsp;
                            <div id="NonVegDiv" class='d-none'>
                                <div class="p-2 pl-4 pt-3 bd-highlight d-flex justify-content-end ">
                                    <label><input class="form-check-input align-content-center checkbox-size  " type="checkbox" value="Non Veg" id="checkNonVeg"><div class="ms-1 mt-1">Non Veg</div></label>
                                </div>
                            </div>
                        </div>
                        <!-- <span class='text-danger' id="inputAddressError"></span> -->
                        &nbsp;
                        &nbsp;

                        <div class="page_4_btns">


                        <div class="row">
                            <div class="col justify-content-start">
                                <button type="button" id="addNewProductPrevBtn" class="btn btn-warning bg-orange basicDetailsBtn">PREVIOUS</button>
                            </div>
                            <div class="col d-flex justify-content-end ">
                                <button type="button" id="addNewProductSubmitBtn" class="btn btn-warning text-uppercase bg-orange basicDetailsBtn">CONTINUE</button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        </div>
    </div>
    
</div>
<!-- <div class="">
    <div class="row">
        <div class="col"></div>
        <div class="col d-flex justify-content-end">
            <button type="button" id="newProdSubmitBtn" class="btn btn-warning basicDetailsBtn text-uppercase bg-orange d-none">CONTINUE</button>
        </div>
    </div>
    <div class="row">
        <div class="col"></div>
        <div class="col d-flex justify-content-end">
            <button type="button" id="verify-OTP-details" class="btn basicDetailsBtn text-uppercase btn-warning bg-orange justify-content-end" data-bs-toggle="modal" data-bs-target="#verify-otp-modal">VERIFY DETAILS</button>
        </div>
    </div>
</div> -->


&nbsp;`;

    $("#productSericeDetailsDiv").append(ele);
    this.bindImagePreview();
    if (
      globalThis.cropperMain &&
      typeof cropperMain.doCroppingAction === "function"
    ) {
      cropperMain.doCroppingAction();
    }
    this.getAllVendorProductsNames();

    // $("#addNewProductSubmitBtn").on("click", this.displayProducts);

    if (this.inputGSTRegistered.is(":checked")) {
      $(".showGSTReg").removeClass("d-none");
    } else {
      $(".showGSTReg").addClass("d-none");
    }

    //////////////////////////////////////////////////////////
    //   FOR ONBOARDING ONLY ONE PRODUCT IMAGE IS REQUIRED  //
    //////////////////////////////////////////////////////////
    img2flag = true;
    img3flag = true;

    const inpFileOne1 = document.getElementById("inpFile1");

    inpFileOne1.addEventListener("change", function () {
      img1flag = true;
      var imgExpression = /.*\.(jpg|jpeg|png|JPG|JPEG|PNG)$/;
      if (!inpFileOne1.files[0]) {
        $("#imagePreview1").empty();
      } else {
        if (!inpFileOne1.files[0]["name"].match(imgExpression)) {
          img1flag = false;
          $("#imagePreview1").empty();
          $(".image-1-error").html("Please select an image file");
        } else {
          $(".image-1-error").html("");

          if (inpFileOne1.files[0]) {
            const reader = new FileReader();

            // previewFileOne1.style.display = "block";
            $("#imagePreview1").empty();
            reader.addEventListener("load", function () {
              var image1 = {
                imageFile: this.result,
                imageNo: "01",
              };
              ProductImages.push(image1);
              // previewFileOne1.setAttribute("src", this.result);
              $("#imagePreview1").append(
                `<img src="${this.result}" alt="" class="image-preview-1 prodImgPreviewForNew"  id="imageCropInputPreviewForNew1" width="220px" height="auto"></img>`,
              );
            });

            reader.readAsDataURL(inpFileOne1.files[0]);
          }
        }
      }
    });
    const inpFiletwo1 = document.getElementById("inpFile2");
    inpFiletwo1.addEventListener("change", function () {
      img2flag = true;

      var imgExpression = /.*\.(jpg|jpeg|png|JPG|JPEG|PNG)$/;
      if (!inpFiletwo1.files[0]) {
        $("#imagePreview2").empty();
      } else {
        if (
          !inpFiletwo1.files[0]["name"].match(imgExpression) ||
          !inpFiletwo1.files[0]["name"]
        ) {
          img2flag = false;
          $(".image-2-error").html("Please select an image file");
          $("#imagePreview2").empty();
        } else {
          $(".image-2-error").html("");

          if (inpFiletwo1.files[0]) {
            const reader = new FileReader();

            // previewFileOne1.style.display = "block";
            $("#imagePreview2").empty();
            reader.addEventListener("load", function () {
              var image2 = {
                imageFile: this.result,
                imageNo: "02",
              };
              ProductImages.push(image2);
              // previewFileOne1.setAttribute("src", this.result);
              $("#imagePreview2").append(
                `<img src="${this.result}" alt="" class="image-preview-2 prodImgPreviewForNew"  id="imageCropInputPreviewForNew2" width="220px" height="auto"></img>`,
              );
            });

            reader.readAsDataURL(inpFiletwo1.files[0]);
          }
        }
      }
    });

    const inpFileThree1 = document.getElementById("inpFile3");
    inpFileThree1.addEventListener("change", function () {
      img3flag = true;
      var imgExpression = /.*\.(jpg|jpeg|png|JPG|JPEG|PNG)$/;
      if (!inpFileThree1.files[0]) {
        $("#imagePreview3").empty();
      } else {
        if (
          !inpFileThree1.files[0]["name"].match(imgExpression) ||
          !inpFileThree1.files[0]["name"]
        ) {
          img3flag = false;
          $(".image-3-error").html("Please select an image file");
          $("#imagePreview3").empty();
        } else {
          $(".image-3-error").html("");

          if (inpFileThree1.files[0]) {
            const reader = new FileReader();

            // previewFileOne1.style.display = "block";
            $("#imagePreview3").empty();
            reader.addEventListener("load", function () {
              var image3 = {
                imageFile: this.result,
                imageNo: "03",
              };
              ProductImages.push(image3);
              // previewFileOne1.setAttribute("src", this.result);
              $("#imagePreview3").append(
                `<img src="${this.result}" alt="" class="image-preview-3 prodImgPreviewForNew"  id="imageCropInputPreviewForNew3" width="220px" height="auto"></img>`,
              );
            });
            reader.readAsDataURL(inpFileThree1.files[0]);
          }
        }
      }
    });
    $("#addNewProductSubmitBtn").on("click", this.doNewProductValidation);
    $("#addNewProductPrevBtn").on("click", this.doNewPrevious);
    $("#inputCategory").on("change", this.vegNonVegShow);
    $("#inputCategory").on("change", this.showSpecialityByCategory);
  };

  vegNonVegShow = () => {
    var extraValue = $("#inputCategory").val();
    const extraValueArray = JSON.parse(extraValue);

    $("#checkNonVeg").prop("checked", false);

    if (extraValueArray.ExtraValue == "FoodSeller" || extraValueArray.IsFood == "1" || extraValueArray.IsFood == 1) {
      $("#NonVegDiv").removeClass("d-none");
    } else {
      $("#NonVegDiv").addClass("d-none");
    }
  };
  vegNonVegShowInEdit = () => {
    var extraValue = $("#inputCategory").val();
    const extraValueArray = JSON.parse(extraValue);

    if (!(extraValueArray.ExtraValue == "FoodSeller" || extraValueArray.IsFood == "1" || extraValueArray.IsFood == 1)) {
      $("#NonVegDiv").addClass("d-none");
    }
  };
  doNewPrevious = () => {
    $("#productSericeDetailsDiv").empty();
    this.productServicesListingPage.removeClass("d-none");
  };

  doNewProductValidation = (e) => {
    e.preventDefault();

    let isProductServiceNameValidated = this.ProductServiceName_validate();
    if (isProductServiceNameValidated) {
      $("#inputProductServiceNameError").html("");
    }

    let isDiscriptionValidated = this.Discription_validate();
    if (isDiscriptionValidated) {
      $("#discriptionError").html("");
    }

    let isCategoryValidated = this.Category_validate();
    if (isCategoryValidated) {
      $("#categoryError1").html("");
    }

    let isPriceValidated = this.Price_validate();
    if (isPriceValidated) {
      $("#priceError").html("");
    }

    let isQuantityValidated = this.Quantity_validate();
    if (isQuantityValidated) {
      $("#quantityError").html("");
    }

    let isGSTPercentValidated = this.GSTPercent_validate();
    if (isGSTPercentValidated) {
      $("#GSTPercentError").html("");
    }

    let imageSelected = this.imageSelected_validate();
    if (imageSelected) {
      $(".image-1-error").html("");
    }

    if (imageIsImage == false) {
      $(".image-1-error").html("Please select an image file");
    }

    if (imageIsImageTwo == false) {
      $(".image-2-error").html("Please select an image file");
    }

    if (imageIsImageThree == false) {
      $(".image-3-error").html("Please select an image file");
    }

    let specialitySelected = this.specialitySelected_validate();
    if (specialitySelected) {
      $("#specicalityError").html(" ");
    }

    //True by default since only 1 prod img mandatory
    //True by default since only 1 prod img mandatory

    if (
      isProductServiceNameValidated &&
      isDiscriptionValidated &&
      isCategoryValidated &&
      isPriceValidated &&
      isQuantityValidated &&
      isGSTPercentValidated &&
      imageSelected &&
      specialitySelected &&
      img1flag &&
      img2flag &&
      img3flag
    ) {
      this.Submit_Form();
    }
  };
  Submit_Form = async () => {
    try {
      console.log("Submit started");
      console.log("SUBMIT FORM CALLED");
      const productName = $("#inputProductServiceName").val();

      //  flags
      const recoFlag = $("#checkreco").is(":checked") ? 1 : 0;
      const NonVegFlag = $("#checkNonVeg").is(":checked") ? 1 : 0;

      //  get files
      const files = [
        document.getElementById("inpFile1")?.files[0],
        document.getElementById("inpFile2")?.files[0],
        document.getElementById("inpFile3")?.files[0],
      ];

      const hasNewImages = files.some((file) => file);
      console.log("FILES:", files);
      console.log("HAS NEW IMAGES:", hasNewImages);

      let ImageURL = "";
      let allImages = [];

      // CASE 1 — NEW IMAGES SELECTED
      if (hasNewImages) {
        console.log("Uploading new images...");

        const uploadRes = await this.uploadProductImages(files, productName);

        console.log("UPLOAD RESPONSE:", uploadRes);

        if (!uploadRes || !uploadRes.urls || uploadRes.urls.length === 0) {
          throw new Error("Image upload failed");
        }

        ImageURL = uploadRes.urls[0];
        allImages = uploadRes.urls;
      } else {
        console.log("Using existing images...");

        // EDIT MODE — reuse old images
        if (this.currentEditingProduct) {
          ImageURL = this.currentEditingProduct.Image_URL;
          allImages = this.currentEditingProduct.Images || [];
        } else {
          throw new Error("No images selected");
        }
      }

      //  category
      const selectedPicklistId = JSON.parse($("#inputCategory").val());

      // specialities
      let SpecialitiesArray = [];
      $(".NewspecialityCheckBox:checked").each(function () {
        SpecialitiesArray.push(this.value);
      });

      // payload
      const product_detail = {
        Product_Service_Name: productName,
        Picklist_ID: selectedPicklistId.picklistId,
        Description: $("trix-editor:visible").val() || $("trix-editor").val(),
        GST: $("#inputGSTPercent").val(),
        Quantity: $("#inputQuantity").val(),
        Price: $("#inputPrice").val(),

        Image_URL: ImageURL,
        Images: allImages,

        Specialities: SpecialitiesArray,
        Recommended_flag: recoFlag,
        Veg_NonVeg_flag: NonVegFlag,
        ImagesUpdated: true,

        // IMPORTANT for edit
        Product_ID: this.currentEditingProduct
          ? this.currentEditingProduct.Product_ID
          : undefined,
      };

      console.log("FINAL PAYLOAD:", product_detail);

      //  SAVE PRODUCT
      const vendorId = localStorage.getItem("Vendor_ID");
      await $.ajax({
        type: "POST",
        url: baseURL + "api/Vendor/AddUpdateProducts",
        headers: { Authorization: X_API_KEY },
        data: {
          product_service_data: [product_detail],
          Vendor_ID: vendorId
        },
      });

      console.log("Product saved successfully");

      //  UI RESET
      this.Products_Services_page4.addClass("d-none");
      this.productServicesListingPage.removeClass("d-none");

      this.displayProducts();
    } catch (err) {
      console.error("Submit failed:", err);
      alert(err.message || "Something went wrong");
    }
  };

  specialitySelected_validate = () => {
    var checkboxs = document.getElementsByClassName("NewspecialityCheckBox");

    var flag = false;
    for (var i = 0, l = checkboxs.length; i < l; i++) {
      if (checkboxs[i].checked) {
        flag = true;
        break;
      }
    }
    if (flag == false) {
      $("#specicalityError").html("Please select a speciality");
    } else {
      $("#specicalityError").html("");
    }
    return flag;
  };

  editspecialitySelected_validate = () => {
    var checkboxs = document.getElementsByClassName("EditspecialityCheckBox");

    var flag = false;
    for (var i = 0, l = checkboxs.length; i < l; i++) {
      if (checkboxs[i].checked) {
        flag = true;
        break;
      }
    }
    if (flag == false) {
      $("#specicalityError").html("Please select a speciality");
    } else {
      $("#specicalityError").html("");
    }
    return flag;
  };

  // imageSelected_validate = () => {
  //   const inpFile = document.getElementById("inpFile");
  //   const inpFileTwo = document.getElementById("inpFileTwo");
  //   const inpFileThree = document.getElementById("inpFileThree");

  //   let flag = true;
  //
  //   //let inputFileOneValue = inpFile.files[0];

  //
  //   if (inpFile.files[0] === undefined) {
  //     this.imageOneError.html("Please select an image");
  //     flag = false;
  //   } else {
  //     this.imageOneError.html("");
  //   }

  //   if (inpFileTwo.files[0] === undefined) {
  //     this.imageTwoError.html("Please select an image");
  //     flag = false;
  //   } else {
  //     this.imageTwoError.html("");
  //   }

  //   if (inpFileThree.files[0] === undefined) {
  //     this.imageThreeError.html("Please select an image");
  //     flag = false;
  //   } else {
  //     this.imageThreeError.html("");
  //   }

  //   return flag;
  // };

  //upload image validation start

  imageSelected_validate = () => {
    const inpFile = document.getElementById("inpFile1");
    const inpFileTwo = document.getElementById("inpFile2");
    const inpFileThree = document.getElementById("inpFile3");

    let flag = true;

    //let inputFileOneValue = inpFile.files[0];

    if (inpFile.files[0] === undefined) {
      $(".image-1-error").html("Please select an image");
      flag = false;
    } else {
      $(".image-1-error").html(" ");
    }

    //////////////////////////////////////////////////////////
    //   FOR ONBOARDING ONLY ONE PRODUCT IMAGE IS REQUIRED  //
    //////////////////////////////////////////////////////////
    // if (inpFileTwo.files[0] === undefined) {
    //   $(".image-2-error").html("Please select an image");
    //

    //   flag = false;
    // } else {
    //   $(".image-2-error").html(" ");
    // }

    // if (inpFileThree.files[0] === undefined) {
    //   $(".image-3-error").html("Please select an image");
    //

    //   flag = false;
    // } else {
    //   $(".image-3-error").html(" ");
    // }
    //////////////////////////////////////////////////////////

    return flag;
  };

  //upload image validation end

  GSTPercent_validate = () => {
    if ($("#inputGSTRegistered").is(":checked")) {
      let flag = true;
      if ($("#inputGSTPercent").val() < 1) {
        $("#GSTPercentError").html("cannot be empty");

        flag = false;
      }

      return flag;
    } else {
      // this.inputGSTPercent.value = null;
      return true;
    }
  };

  ProductServiceName_validate = () => {
    let flag = true;
    for (let i = 0; i < vendorProductNames.length; i++) {
      if ($("#inputProductServiceName").val() == vendorProductNames[i]) {
        $("#inputProductServiceNameError").html("Product already exists.");

        flag = false;
      }
      if ($("#inputProductServiceName").val() == currentEditedproductName) {
        $("#inputProductServiceNameError").html("");

        flag = true;
      }
    }
    if (
      $("#inputProductServiceName").val().length < 2 ||
      $("#inputProductServiceName").val().length > 50
    ) {
      $("#inputProductServiceNameError").html(
        "name should be min 2 and max 50 characters long",
      );

      flag = false;
    }

    return flag;
  };
  Discription_validate = () => {
    let flag = true;
    var element = $("trix-editor:visible")[0] || document.querySelector("trix-editor");
    var trixdocumentstr = "";
    if (element && element.editor) {
      trixdocumentstr = element.editor.getDocument().toString();
    } else {
      var htmlStr = $(element).val() || "";
      trixdocumentstr = $("<div>").html(htmlStr).text();
    }

    if (trixdocumentstr.length > 5000 || trixdocumentstr.length < 2) {
      $("#discriptionError").html("description must be max 5000 characters");

      flag = false;
    }

    return flag;
  };

  Category_validate = () => {
    let flag = true;

    if (!$("#inputCategory").val()) {
      $("#categoryError1").html("Select a Category");

      flag = false;
    }

    return flag;
  };

  Price_validate = () => {
    let flag = true;
    if ($("#inputPrice").val() > 1000000 || $("#inputPrice").val() < 1) {
      $("#priceError").html("max 10,00,000");

      flag = false;
    }

    return flag;
  };

  Quantity_validate = () => {
    let flag = true;
    if ($("#inputQuantity").val() < 1) {
      $("#quantityError").html("min 1");

      flag = false;
    }

    return flag;
  };

  ValidateAtleastOneProduct = () => {
    $.ajax({
      type: "GET",
      url: baseURL + "api/Vendor/GetProducts",
      headers: { Authorization: X_API_KEY },
      success: this.SubmitListingPage,
    });
  };

  SubmitListingPage = (res) => {
    if (res.code == 10) {
      this.NoProductsError.html("Please add atleast one product");
    } else {
      this.uploadDocuments_page5.removeClass("d-none");
      this.productServicesListingPage.addClass("d-none");
      this.formstep4.removeClass("current-item");
      this.formstep5.addClass("current-item");
    }
  };
  // getProducts = (e) => {
  //
  //   $.ajax({
  //     type: "GET",
  //     url: baseURL + "api/Vendor/GetProducts",
  //     headers: { Authorization: X_API_KEY },
  //     success: this.doDisplayProds,
  //   });
  // };
  // doDisplayProds = (res) => {
  //
  //
  // };

  //getting all the Vendor product names to validate unique product names
  getAllVendorProductsNames = async () => {
    await new Promise((resolve) => {
      const vendorId = localStorage.getItem("Vendor_ID");
      $.ajax({
        type: "GET",
        url: baseURL + "api/Vendor/GetVendorProductsNames",
        headers: { Authorization: X_API_KEY },
        data: { Vendor_ID: vendorId },
        success: (res) => {
          this.useVendorProducts(res);
          resolve();
        },
        error: resolve,
      });
    });
  };

  useVendorProducts = (res) => {
    vendorProductNames = [];
    if (!res.code) {
      res.forEach((element) => {
        vendorProductNames.push(element.Product_Service_Name);
      });
    }
  };

  showSpecialityByCategory = async (e) => {
    const categoryOptions = document.getElementsByClassName("categoryOptions");

    for (var i = 0; i < categoryOptions.length; i++) {
      if (categoryOptions[i].selected == true) {
        var picklistId = $("#inputCategory").val();
        const picklistIdArray = JSON.parse(picklistId);

        await new Promise((resolve) => {
          $.ajax({
            type: "GET",
            url: baseURL + "api/Vendor/getSpecialitiesForCategory",
            data: {
              Picklist_ID: picklistIdArray.picklistId,
              Product_ID: currentProductID,
              Vendor_ID: localStorage.getItem("Vendor_ID"),
            },
            headers: { Authorization: X_API_KEY },

            success: (res) => {
              this.showSpecialities(res);
              resolve();
            },
            error: resolve,
          });
        });
      }
    }
  };

  showSpecialities = (res) => {
    var SpecialityCount = 50;
    var newProductSpecility = ``;
    var checked = ``;

    res.forEach((element) => {
      checked = element.Selected ? "checked" : "";

      const initialImageSrc = getImageUrl(
        element.Picklist_Image_Url || element.Icon_Url,
      );

      newProductSpecility = `${newProductSpecility}<div class="col-4 col-md-2 d-flex justify-content-center my-2 "><div class="custom-control custom-checkbox image-checkbox">
        <input type="checkbox" class="custom-control-input specialityCheckBox NewspecialityCheckBox EditspecialityCheckBox justify-content-center" id="specialityck${SpecialityCount}" value="${element.Picklist_ID}" ${checked}>
        <label class="custom-control-label d-flex justify-content-center" for="specialityck${SpecialityCount}">
            <img src="${initialImageSrc}" id=${element.Picklist_ID} class="img-fluid specialityImage" style="width: 96px; height: 96px; object-fit: contain; background-color: #f5f5f5; padding: 6px; border-radius: 8px;" onerror="this.src='${baseURL}/assets/default.png'" alt="Image" loading="lazy">
        </label>
        <label class="d-flex justify-content-center">
            <span class="fs-12 text-lowercase text-center">${element.Picklist_display_value}</span>
        </label>
        </div></div>`;
      SpecialityCount++;
    });
    $("#ProductSpecialityBox").empty();
    $("#ProductSpecialityBox").append(newProductSpecility);
    //Call to Function to load the S3 Category images in the respective image tags
    this.loadSpecialityImages(res);
  };

  loadSpecialityImages = (res) => {
    //For each Speciality in Category ABC
    res.forEach((elementS) => {
      const imgElement = document.getElementById(elementS.Picklist_ID);
      if (!imgElement) return;

      const imageUrl = getImageUrl(
        elementS.Picklist_Image_Url || elementS.Icon_Url,
      );
      if (imageUrl) {
        imgElement.src = imageUrl;
      } else {
        // No image available - show placeholder icon
        imgElement.src = baseURL + "/assets/default.png";
      }
    });
  };

  doAfterSuccessfulEdit = (res) => {
    if (res == "needReAuthentication") {
      $("#prodToBeAuthorizedMsg").html(
        "Locaso will approve the changes made to the product.",
      );
      window.$("#prodToBeAuthorized").modal("show");
      $("#prodToBeAuthorizedCloseBtn").on("click", () => {
        window.$("#prodToBeAuthorized").modal("hide");
      });
    }
  };

  uploadProductImages = async (files, productName) => {
    const formData = new FormData();
    let imageIndex = 0; // start from 0

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!file) continue;

      let base64 = null;
      const editPreview = document.getElementById(
        `servicingimageCropInputPreviewForEdit${i + 1}`,
      );
      const newPreview = document.getElementById(
        `imageCropInputPreviewForNew${i + 1}`,
      );

      if (editPreview && editPreview.src?.startsWith("data:image")) {
        base64 = editPreview.src;
      } else if (newPreview && newPreview.src?.startsWith("data:image")) {
        base64 = newPreview.src;
      } else {
        base64 = await toBase64(file);
      }

      formData.append(`ProductImages[${imageIndex}][imageFile]`, base64);
      formData.append(`ProductImages[${imageIndex}][imageNo]`, imageIndex + 1);

      imageIndex++;
    }

    formData.append("productServiceName", productName);
    formData.append("Product_ID", currentProductID);
    const vendorId = localStorage.getItem("Vendor_ID");
    if (vendorId) {
      formData.append("Vendor_ID", vendorId);
    }

    console.log([...formData.entries()]);

    const res = await fetch(baseURL + "api/Vendor/ImageUploadApi", {
      method: "POST",
      headers: {
        Authorization: X_API_KEY,
      },
      body: formData,
    });

    return await res.json();
  };
}

